import { JourneyConfigState } from '../../store/state';
import { JourneyAction, JourneyActions } from '../actions/journey';

const initialState: JourneyConfigState = {
  configID: null,
  data: null,
  previous: null,
  isLoading: false,
  loaded: false,
  error: '',
  saving: false
};

const journeyReducer = (state: JourneyConfigState = initialState, action: JourneyAction): JourneyConfigState => {
  switch (action.type) {
    case JourneyActions.GetActiveConfig:
      return {
        configID: null,
        data: null,
        previous: null,
        isLoading: true,
        loaded: false,
        error: null,
        saving: true,
      };
    case JourneyActions.GetActiveConfigSuccess:
      return {
        configID: action.id,
        data: action.config,
        previous: action.previous,
        isLoading: false,
        loaded: true,
        error: null,
        saving: false,
      };
    case JourneyActions.GetActiveConfigError:
      return {
        configID: null,
        data: null,
        previous: null,
        isLoading: false,
        loaded: false,
        error: null,
        saving: false
      };
    case JourneyActions.CreateConfigSuccess:
      return {
        configID: action.payload,
        data: null,
        previous: null,
        isLoading: false,
        loaded: true,
        error: null,
        saving: false
      };
    case JourneyActions.CreateConfigError:
      return {
        configID: null,
        data: null,
        previous: null,
        isLoading: false,
        loaded: false,
        error: action.payload,
        saving: false,
      };
    case JourneyActions.UpdateConfig:
    case JourneyActions.ReplaceConfig:
    case JourneyActions.UploadVehicleImage:
      return {
        ...state,
        saving: true
      };
    case JourneyActions.UpdateConfigSuccess:
    case JourneyActions.ReplaceConfigSuccess:
    case JourneyActions.UploadVehicleImageSuccess:
      return {
        ...state,
        saving: false
      };
    case JourneyActions.UpdateConfigError:
    case JourneyActions.ReplaceConfigError:
      return {
        ...state,
        saving: false,
        error: action.payload
      }
    default:
      return state;
  }
};

export default journeyReducer;
